import { createSelector } from 'reselect';

import { StoreState } from '../interfaces';
import { AppState } from '../reducers';
import { HomographyState } from '../reducers/homography/homographyState';

export const selectStore = (state: AppState): StoreState => state.store;

export const selectHomography = (state: AppState): HomographyState => state.homography;

export const selectFleet = createSelector(selectStore, (store) => store.fleet);
